import React from 'react';
import { motion } from 'framer-motion';
export function ResearchSection() {
  return <section className="w-full bg-slate-50" data-id="element-103" data-mp="39czx7qzoyo8o">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-stretch gap-12 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-104" data-mp="39byjferajnn9">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-left" data-id="element-105" data-mp="3i5jxevvmt0vm">
          <h2 className="font-display text-2xl font-bold leading-snug text-[var(--color-navy)] sm:text-3xl" data-id="element-106" data-mp="2qenmi0t4t6az">
            Families Are Researching You Online Before They Ever Call
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-700" data-id="element-107" data-mp="2zgdeb7qxe79a">
            Adult children are the ones searching, comparing, and shortlisting communities — often late at night on a phone.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-108" data-mp="eqxs6q2nj6pz">
            If your site is slow, hard to navigate, or does not clearly explain your levels of care and pricing, they move to the next community on the list.
          </p>
          <p className="mt-4 text-lg font-medium leading-relaxed text-[var(--color-navy)]" data-id="element-109" data-mp="2k0zfepp5soic">
            At Mannix Marketing, we build senior living websites that answer the questions families actually have, then guide them to a tour request or an application.
          </p>
          <a href="#consultation-form" className="mt-8 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-[var(--color-navy)] px-6 py-4 text-xs font-bold uppercase tracking-wide text-white transition-colors hover:bg-[var(--color-navy-light)] sm:px-8 sm:text-sm" data-id="element-110" data-mp="2b2ndvsmr86b4">
            Schedule Your Free Consultation
          </a>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="min-h-[320px] overflow-hidden rounded-2xl shadow-xl" data-id="element-111" data-mp="1rcbq8j1ahezi">
          <img src="https://cdn.magicpatterns.com/uploads/7oAZumKa1Q5hzW3YQaPnqM/118910537_m.webp" alt="A family gathered around a laptop researching senior living communities together" className="h-full w-full object-cover" data-id="element-112" data-mp="13pg6mcgu33kz" />
        </motion.div>
      </div>
    </section>;
}